var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3568 14.456C29.8449 14.6767 29.2888 14.8355 28.715 14.8973C29.3064 14.5442 29.7566 13.9881 29.9684 13.3261C29.4212 13.6527 28.8033 13.891 28.1589 14.0146C27.6381 13.4585 26.8966 13.1143 26.0757 13.1143C24.4956 13.1143 23.2245 14.3942 23.2245 15.9654C23.2245 16.1861 23.251 16.4068 23.2952 16.6186C20.9295 16.495 18.8198 15.3652 17.4163 13.6351C17.1691 14.0588 17.0279 14.5442 17.0279 15.0739C17.0279 16.0625 17.531 16.9364 18.299 17.4484C17.8312 17.4307 17.3898 17.2983 17.0102 17.0865C17.0102 17.0953 17.0102 17.1129 17.0102 17.1218C17.0102 18.5076 17.9901 19.6551 19.2965 19.92C19.0581 19.9818 18.8022 20.0171 18.5462 20.0171C18.3608 20.0171 18.1843 19.9994 18.0077 19.9729C18.3696 21.1028 19.42 21.9237 20.6735 21.9502C19.6937 22.7182 18.4667 23.1683 17.1338 23.1683C16.8955 23.1683 16.6748 23.1595 16.4453 23.133C17.7076 23.9451 19.2082 24.413 20.8236 24.413C26.0669 24.413 28.9357 20.07 28.9357 16.3008C28.9357 16.1773 28.9357 16.0537 28.9268 15.9301C29.483 15.5241 29.9684 15.0209 30.3568 14.456Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5832",
    x: -7,
    y: -9,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.52549 0 0 0 0 0.898039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5832",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.4db1b776952bf8f22a1d193f86073194.svg";
export { ForwardRef as ReactComponent };